import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToolLeadServices } from 'Services/axios/ToolLead.Service';
import { checkFilter } from 'Features/Common/CommonUtils';
import { handleApiError } from 'Features/Common/ErrorHandler';
import { toast } from 'react-toastify';

const parseBlobError = async (error) => {
	const data = error?.response?.data;
	if (!(data instanceof Blob)) {
		return error;
	}

	try {
		const text = await data.text();
		const json = JSON.parse(text);
		error.response.data = json;
	} catch (_) {
		// Biarkan handleApiError memakai fallback status bila bukan JSON.
	}

	return error;
};

const getFilenameFromDisposition = (contentDisposition, fallback) => {
	if (!contentDisposition) {
		return fallback;
	}

	const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
	if (utfMatch?.[1]) {
		return decodeURIComponent(utfMatch[1]);
	}

	const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
	if (plainMatch?.[1]) {
		return plainMatch[1];
	}

	return fallback;
};

const downloadBlob = (blob, filename) => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};

export const fetchToolLeads = createAsyncThunk(
	'ToolLeads/fetchToolLeads',
	async (filters) => {
		try {
			const newFilter = checkFilter(filters);
			const response = await ToolLeadServices.getAll(newFilter);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const fetchToolLeadConfig = createAsyncThunk(
	'ToolLeads/fetchToolLeadConfig',
	async () => {
		try {
			const response = await ToolLeadServices.getConfig();
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const fetchToolLeadDetail = createAsyncThunk(
	'ToolLeads/fetchToolLeadDetail',
	async (id) => {
		try {
			const response = await ToolLeadServices.getAll({
				'filter[id]': id,
				include: 'data',
				per_page: 1,
			});
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);

export const exportToolLeads = createAsyncThunk(
	'ToolLeads/exportToolLeads',
	async (filters) => {
		try {
			const newFilter = checkFilter(filters);
			const response = await ToolLeadServices.export(newFilter);
			const disposition = response.headers?.['content-disposition'];
			const format = newFilter.format === 'csv' ? 'csv' : 'xlsx';
			const filename = getFilenameFromDisposition(
				disposition,
				`Tool_Leads_export.${format}`
			);
			downloadBlob(response.data, filename);
			toast.success('Export berhasil diunduh.');
			return true;
		} catch (error) {
			const parsed = await parseBlobError(error);
			handleApiError(parsed);
			throw parsed;
		}
	}
);

export const deleteToolLead = createAsyncThunk(
	'ToolLeads/deleteToolLead',
	async (id) => {
		try {
			const response = await ToolLeadServices.delete(id);
			return response.data;
		} catch (error) {
			handleApiError(error);
			throw error;
		}
	}
);
